import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "min-h-screen bg-gray-100" };
const _hoisted_2 = { class: "border-b border-gray-100 bg-white" };
const _hoisted_3 = { class: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" };
const _hoisted_4 = { class: "flex h-16 justify-between" };
const _hoisted_5 = { class: "flex" };
const _hoisted_6 = { class: "flex shrink-0 items-center" };
const _hoisted_7 = { class: "hidden space-x-8 sm:-my-px sm:ms-10 sm:flex" };
const _hoisted_8 = { class: "hidden sm:ms-6 sm:flex sm:items-center" };
const _hoisted_9 = { class: "relative ms-3" };
const _hoisted_10 = { class: "inline-flex rounded-md" };
const _hoisted_11 = {
    type: "button",
    class: "inline-flex items-center rounded-md border border-transparent bg-white px-3 py-2 text-sm font-medium leading-4 text-gray-500 transition duration-150 ease-in-out hover:text-gray-700 focus:outline-none"
};
const _hoisted_12 = { class: "-me-2 flex items-center sm:hidden" };
const _hoisted_13 = {
    class: "h-6 w-6",
    stroke: "currentColor",
    fill: "none",
    viewBox: "0 0 24 24"
};
const _hoisted_14 = { class: "space-y-1 pb-3 pt-2" };
const _hoisted_15 = { class: "border-t border-gray-200 pb-1 pt-4" };
const _hoisted_16 = { class: "px-4" };
const _hoisted_17 = { class: "text-base font-medium text-gray-800" };
const _hoisted_18 = { class: "text-sm font-medium text-gray-500" };
const _hoisted_19 = { class: "mt-3 space-y-1" };
const _hoisted_20 = {
    key: 0,
    class: "bg-white shadow"
};
const _hoisted_21 = { class: "mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8" };
import { ref } from 'vue';
import ApplicationLogo from '@/Components/ApplicationLogo.vue';
import Dropdown from '@/Components/Dropdown.vue';
import DropdownLink from '@/Components/DropdownLink.vue';
import NavLink from '@/Components/NavLink.vue';
import ResponsiveNavLink from '@/Components/ResponsiveNavLink.vue';
import { Link } from '@inertiajs/vue3';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AuthenticatedLayout',
    setup(__props) {
        const showingNavigationDropdown = ref(false);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("nav", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createVNode(_unref(Link), {
                                            href: _ctx.route('dashboard')
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(ApplicationLogo, { class: "block h-9 w-auto fill-current text-gray-800" })
                                            ]),
                                            _: 1
                                        }, 8, ["href"])
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createVNode(NavLink, {
                                            href: _ctx.route('dashboard'),
                                            active: _ctx.route().current('dashboard')
                                        }, {
                                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                    _createTextVNode(" Dashboard ", -1)
                                                ]))]),
                                            _: 1
                                        }, 8, ["href", "active"])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createVNode(Dropdown, {
                                            align: "right",
                                            width: "48"
                                        }, {
                                            trigger: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_10, [
                                                    _createElementVNode("button", _hoisted_11, [
                                                        _createTextVNode(_toDisplayString(_ctx.$page.props.auth.user.name) + " ", 1),
                                                        _cache[2] || (_cache[2] = _createElementVNode("svg", {
                                                            class: "-me-0.5 ms-2 h-4 w-4",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 20 20",
                                                            fill: "currentColor"
                                                        }, [
                                                            _createElementVNode("path", {
                                                                "fill-rule": "evenodd",
                                                                d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                                                                "clip-rule": "evenodd"
                                                            })
                                                        ], -1))
                                                    ])
                                                ])
                                            ]),
                                            content: _withCtx(() => [
                                                _createVNode(DropdownLink, {
                                                    href: _ctx.route('profile.edit')
                                                }, {
                                                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                                            _createTextVNode(" Profile ", -1)
                                                        ]))]),
                                                    _: 1
                                                }, 8, ["href"]),
                                                _createVNode(DropdownLink, {
                                                    href: _ctx.route('logout'),
                                                    method: "post",
                                                    as: "button"
                                                }, {
                                                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                                            _createTextVNode(" Log Out ", -1)
                                                        ]))]),
                                                    _: 1
                                                }, 8, ["href"])
                                            ]),
                                            _: 1
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("button", {
                                        onClick: _cache[0] || (_cache[0] = ($event) => (showingNavigationDropdown.value =
                                            !showingNavigationDropdown.value)),
                                        class: "inline-flex items-center justify-center rounded-md p-2 text-gray-400 transition duration-150 ease-in-out hover:bg-gray-100 hover:text-gray-500 focus:bg-gray-100 focus:text-gray-500 focus:outline-none"
                                    }, [
                                        (_openBlock(), _createElementBlock("svg", _hoisted_13, [
                                            _createElementVNode("path", {
                                                class: _normalizeClass({
                                                    hidden: showingNavigationDropdown.value,
                                                    'inline-flex': !showingNavigationDropdown.value,
                                                }),
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "2",
                                                d: "M4 6h16M4 12h16M4 18h16"
                                            }, null, 2),
                                            _createElementVNode("path", {
                                                class: _normalizeClass({
                                                    hidden: !showingNavigationDropdown.value,
                                                    'inline-flex': showingNavigationDropdown.value,
                                                }),
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "2",
                                                d: "M6 18L18 6M6 6l12 12"
                                            }, null, 2)
                                        ]))
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", {
                            class: _normalizeClass([{
                                    block: showingNavigationDropdown.value,
                                    hidden: !showingNavigationDropdown.value,
                                }, "sm:hidden"])
                        }, [
                            _createElementVNode("div", _hoisted_14, [
                                _createVNode(ResponsiveNavLink, {
                                    href: _ctx.route('dashboard'),
                                    active: _ctx.route().current('dashboard')
                                }, {
                                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                            _createTextVNode(" Dashboard ", -1)
                                        ]))]),
                                    _: 1
                                }, 8, ["href", "active"])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$page.props.auth.user.name), 1),
                                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$page.props.auth.user.email), 1)
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    _createVNode(ResponsiveNavLink, {
                                        href: _ctx.route('profile.edit')
                                    }, {
                                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                _createTextVNode(" Profile ", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["href"]),
                                    _createVNode(ResponsiveNavLink, {
                                        href: _ctx.route('logout'),
                                        method: "post",
                                        as: "button"
                                    }, {
                                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                                _createTextVNode(" Log Out ", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["href"])
                                ])
                            ])
                        ], 2)
                    ]),
                    (_ctx.$slots.header)
                        ? (_openBlock(), _createElementBlock("header", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _renderSlot(_ctx.$slots, "header")
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("main", null, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ])
            ]));
        };
    }
});
